<template>
  <Modal
    v-model="shows"
    title="报警详情"
    ref="modal"
    draggable
    class-name="vertical-center-modal"
    ok-text="确认"
    width="960"
    height="600"
    @on-cancel="shows = false"
  >
    <VTabel
        :height="400"
      :columns="columns"
      :data="dataList"
      :total="query.total"
          :loading="loading"
          @onPageChange="onPageChange"
          @onPageSizeChange="onPageSizeChange"
    ></VTabel>
  </Modal>
</template>

<script>
import api from "../../../../../../api/request.js";
import Cookies from "js-cookie";
import VTabel from "@/components/components/VTable/index.vue";
import defaultData from "./columns.js";

const URL = {
    GetDeviceAbnormalPageListWith3Code:
    "api/YhjStatic/GetDeviceAbnormalPageListWith3Code", // 设备告警
    ProcessUserDeviceAbnormal: "api/YhjDevice/ProcessUserDeviceAbnormal" // 操作
};

export default {
  components: {
    VTabel
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
        loading: false,
        query: {
        page: 1,
        size: 15,
        total: 0,
        deviceCode: ""
      },
        dataList: []
    };
  },
  watch: {
    show(value) {
      if (value) {
          this.query.deviceCode = this.data.DeviceCode
        this.GetDeviceAbnormalPageListWith3Code(1);
      }
    },
  },
  computed: {
      columns() {
      return defaultData.columns(this);
    },
    shows: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      },
    },
  },
  methods: {
    onPageChange(value) {
      this.query.page = value;
      this.GetDeviceAbnormalPageListWith3Code();
    },
    onPageSizeChange(value) {
      this.query.page = 1;
      this.query.size = value;
      this.GetDeviceAbnormalPageListWith3Code();
    },
    GetDeviceAbnormalPageListWith3Code(
      page = this.query.page,
      size = this.query.size
    ) {
      const { GroupCode, DepartmentCode, CompanyCode, IsAdmin } = JSON.parse(
        Cookies.get("AdminData")
      );
      this.loading = true;
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `${URL.GetDeviceAbnormalPageListWith3Code}?groupCode=${GroupCode}&companyCode=${CompanyCode}&departmentCode=${DepartmentCode}&deviceCode=${this.query.deviceCode}&pageIndex=${page}&pageSize=${size}&pstate=1&isAdmin=${IsAdmin}&deviceType=qg`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token")
          }
        },
        "yhj"
      )
        .then(res => {
          if (res.Success) {
            this.dataList = res.Data || [];
            this.query = {
              ...this.query,
              page,
              size,
              total: res.TotalCount
            };
          } else {
            this.$Message["error"]({
              background: true,
              content: res.Message
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 及时告警信息处理 type 2、处理 3、误报（yhj）
    SolveAbData(Id, type) {
      this.shows = false
      let _this = this,
        AdminData = JSON.parse(Cookies.get("AdminData"));
      _this.$Modal.confirm({
        title: "提示",
        content: `<p>是否对设备进行${type == 2 ? "处理" : "误报"}操作</p>`,
        onOk: () => {
          api(
            {
              //这里是你自己的请求方式、url和data参数
              method: "get",
              url: `${URL.ProcessUserDeviceAbnormal}?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&userDeviceAbnormal_Id=${Id}&pstate=${type}`,
              data: {},
              //假设后台需要的是表单数据这里你就可以更改
              headers: {
                "Content-Type":
                  "application/x-www-form-urlencoded;charset=UTF-8",
                Authorization: Cookies.get("Token")
              }
            },
            "yhj"
          ).then(res => {
            this.shows = true
            if (res.Success) {
              _this.$Message["success"]({
                background: true,
                content: res.Message
              });
              // 根据集团 公司 部门获取设备异常（yhj）
              _this.GetDeviceAbnormalPageListWith3Code();
              _this.$store.dispatch("setUseGasState", true);
            } else {
              _this.$Message["error"]({
                background: true,
                content: res.Message
              });
            }
          });
        },
        onCancel: () => {
          this.shows = true
        }
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/useGas/views/alarm/mods/detail/indev.vue